module.exports = __webpack_public_path__ + "static/img/drone_05.eb56de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_05.jpg
// module id = yaNa
// module chunks = 0